import { useContext, useEffect, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { ImagesContext } from '../../../contexts/ImagesContext';
import { ImageTypeValue } from '../../../utils/image';
import InputImage from '../../../components/Form/InputImage';
import Paginator from '../../../components/Paginator';
import DeleteModal from '../../../components/Modals/DeleteModal/DeleteModal';
import Img from '../../../components/Img';

const BlockImagesManagement = () => {
  // states
  const [deletingImage, setDeletingImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const {
    GetImages,
    images,
    total,
    links,
    currentPage,
    fromItem,
    toItem,
    destroyImage,
  } = useContext(ImagesContext);

  const changePage = (page: number) => {
    GetImages(ImageTypeValue.MY_IMAGE, page);
  };

  const handleDeleteSubmit = () => {
    if (deletingImage === null) {
      return;
    }
    destroyImage(deletingImage.id, () => {
      GetImages(ImageTypeValue.MY_IMAGE, currentPage);
      setDeletingImage(null);
    });
  };

  const handleImageUpload = async () => {
    GetImages(ImageTypeValue.MY_IMAGE, 1);
  };

  useEffect(() => {
    GetImages(ImageTypeValue.MY_IMAGE, 1);
  }, [GetImages]);

  return (
    <div className="main">
      <main
        style={{
          overflowY: 'auto',
          height: 'calc(100vh - 65px)',
        }}
      >
        <div className="container-fluid p-3">
          <div className="mb-3">
            <h3 className="h3 d-inline align-middle">画像管理</h3>
          </div>
          {errorMessage && (
            <div className="alert alert-danger alert-dismissible fade show" role="alert">
              <strong>{errorMessage}</strong>
            </div>
          )}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="h4 float-start mt-2">マイ画像一覧</h4>
                  <div className="float-end mr-1">
                    <Button
                      className="btn btn-primary"
                      variant="contained"
                      component="label"
                      disabled={isLoading}
                      sx={{
                        position: 'relative',
                      }}
                    >
                      {
                        isLoading
                          ? (<CircularProgress size={20} />)
                          : (
                            <>
                              <span>画像をアップロードする ...</span>
                              <InputImage
                                type={ImageTypeValue.MY_IMAGE}
                                id="id"
                                isDisabled={false}
                                fileHandler={handleImageUpload}
                                setIsLoading={setIsLoading}
                                onMaxFileSizeExceeded={(message) => setErrorMessage(message)}
                              />
                            </>
                          )
                      }
                    </Button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="image-list">
                    {images.map((image) => (
                      <div className="card" key={image.id}>
                        <div className="card-body">
                          <div className="image-image">
                            <Img src={image.thumbnail} alt="" />
                          </div>
                        </div>
                        <div className="image-btn-top-right hover-view">
                          <button
                            className="block-circle-btn-delete"
                            data-bs-toggle="modal"
                            data-bs-target="#blockdeleteModal"
                            type="button"
                            onClick={() => setDeletingImage(image)}
                          >
                            <i className="fa-regular fa-trash-can fa-fw" />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="row mt-1 block-list-footer">
                    <div className="col-6">
                      <div className="paging-info d-flex justify-content-start align-items-center mt-2">
                        <div>
                          {' '}
                          全
                          {' '}
                          {total}
                          {' '}
                          件中
                          {' '}
                          {fromItem}
                          {' '}
                          〜
                          {toItem}
                          {' '}
                          件を表示
                        </div>
                      </div>
                    </div>
                    <div className="col-6 d-flex justify-content-end mt-2">
                      <div>
                        <Paginator currentPage={currentPage} changePage={changePage} links={links} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DeleteModal
          title="画像削除"
          open={deletingImage != null}
          handleClose={() => setDeletingImage(null)}
          handleSave={handleDeleteSubmit}
          desc="この画像は他で使用されている可能性があります。 本当に画像を削除してもよろしいですか？"
        />
      </main>
    </div>
  );
};

export default BlockImagesManagement;
